export default __webpack_public_path__ + "static/media/01_whale_m.005d98a7.webp";